import { Controller } from 'react-hook-form'

import { Input, InputProps } from './Input'

interface InputControlledProps extends InputProps {
  control: any
  name: string
  customOnChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const InputControlled = ({ control, customOnChange, ...inputProps }: InputControlledProps) => {
  return (
    <Controller
      control={control}
      name={inputProps.name}
      render={({ field: { onChange, value, ref } }) => (
        <Input {...inputProps} ref={ref} onChange={customOnChange || onChange} value={value} />
      )}
    />
  )
}
